"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilterBuildsPreference = exports.getComponentsPreference = exports.getOnlyRecentPreference = exports.getShowPreference = exports.DEFAULT_ONLY_RECENT_PREFERENCE = exports.DEFAULT_SHOW_PREFERENCE = void 0;
exports.DEFAULT_SHOW_PREFERENCE = 'only_assigned';
exports.DEFAULT_ONLY_RECENT_PREFERENCE = false;
function getShowPreference(profile) {
    if (!profile || !profile.preferences || !profile.preferences.show) {
        return exports.DEFAULT_SHOW_PREFERENCE;
    }
    return profile.preferences.show;
}
exports.getShowPreference = getShowPreference;
function getOnlyRecentPreference(profile) {
    if (!profile ||
        !profile.preferences ||
        typeof profile.preferences.onlyRecent === 'undefined') {
        return exports.DEFAULT_ONLY_RECENT_PREFERENCE;
    }
    return profile.preferences.onlyRecent;
}
exports.getOnlyRecentPreference = getOnlyRecentPreference;
function getComponentsPreference(profile) {
    if (!profile || !profile.preferences || !profile.preferences.components) {
        return [];
    }
    return profile.preferences.components;
}
exports.getComponentsPreference = getComponentsPreference;
function getFilterBuildsPreference(profile) {
    if (!profile ||
        !profile.preferences ||
        typeof profile.preferences.filterBuilds === 'undefined') {
        return true;
    }
    return profile.preferences.filterBuilds;
}
exports.getFilterBuildsPreference = getFilterBuildsPreference;
//# sourceMappingURL=profile.js.map